<template>
    <div class="content">
        
        <el-row >
            <el-col :span="10" :offset="1">
                <div class="left">
                    <div class="info">
                        <el-row  type="flex" justify="space-around" class="info-list">
                            <el-col :span="6">用户账号 :</el-col>
                            <el-col :span="18">{{userInformation.userId}}</el-col>
                        </el-row>
                        <el-row  type="flex" justify="space-around" class="info-list">
                            <el-col :span="6">用户名称 :</el-col>
                            <el-col :span="18">{{userInformation.name}}</el-col>
                        </el-row>
                        <el-row  type="flex" justify="space-around" class="info-list">
                            <el-col :span="6">用户级别 :</el-col>
                            <el-col :span="18">{{userLevel}}</el-col>
                        </el-row>
                        <el-row  type="flex" justify="space-around" class="info-list">
                            <el-col :span="6">销售地点 :</el-col>
                            <el-col :span="18">{{userInformation.location}}</el-col>
                        </el-row>
                    </div>
                </div>
                <div class="right">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="个人设置" name="second" class="content">
                            <el-row>
                                <el-col :span="20">
                                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                                        <el-form-item label="用户名称" prop="name">
                                            <el-input v-model="ruleForm.name"></el-input>
                                        </el-form-item>
                                          <el-form-item v-if="bigCusApplePhone" label="联系方式" prop="phone">
                                            <el-input v-model="ruleForm.phone"></el-input>
                                        </el-form-item>
                                        <el-form-item label="用户密码" prop="password" >
                                            <el-input type="password" autocomplete="off" v-model="ruleForm.password"></el-input>
                                        </el-form-item>
                                         <el-form-item label="确认密码" prop="checkPass">
                                            <el-input v-model="ruleForm.checkPass" type="password" autocomplete="off"></el-input>
                                        </el-form-item>
                                        <el-form-item class="submit">
                                            <el-button-group>
                                                <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                                                <el-button @click="cancel()">返回</el-button>
                                            </el-button-group>
                                            
                                        </el-form-item>
                                    </el-form>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </el-col>
        </el-row>
        
    </div>
</template>
<script>
import axios from '../../env/axios'
import apis from '../../env/apis'
import requestMixin from '../../mixins/request'
import commonMixin from '../../mixins/common'
export default {
    mixins : [requestMixin, commonMixin],
    data(){
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            let checkPass = this.ruleForm.checkPass;
            if (value === '') {
            callback(new Error('请再次输入密码'));
            } else if (checkPass !== this.ruleForm.password) {
            callback(new Error('两次输入密码不一致!'));
            } else {
            callback();
            }
        };
        var validatePhone=(rule, value, callback)=>{
             let phone=this.ruleForm.phone;
             if(value==''){
                callback(new Error('请输入手机号'));
             }else{
                callback();
             }    
        }

        return {
            activeName : "second",
            bigCusApplePhone:false,   
            ruleForm: {
                name: '',
                userId:'',
                lastUpdateDate:'',
                password:'',  //输入密码
                phone:'', //联系方式
                checkPass:''  
            },
            userLevel: '',
            name:'',
            userInformation:{
                name: '',
                userId:'',
                location:'',
                password:'',  
                checkPass:''
            },
            rules: {
                name: [
                    { required: true, message: '请输入用户名称', trigger: 'blur' },
                    { min: 3, max: 50, message: '长度在 3 到 50 个字符', trigger: 'blur' }
                ],
                password: [
                    { validator: validatePass, trigger: 'blur',required:true },
                    { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }  
                ],
                checkPass:[
                    { validator: validatePass2, trigger: 'blur',required:true },
                    { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
                ],
                phone:[
                    { required: true, trigger: 'blur',required:true },
                    { min: 11, max: 13, message: '长度在 11到 13 个字符', trigger: 'blur' }  
                ]   
            }
        }
    },
    mounted(){
        this.$nextTick(() =>{
            let userId = sessionStorage.getItem('userId');
            this.ruleForm.userId = userId;
            if(userId=='SYSADMIN'){
                this.bigCusApplePhone=true;
            }
            this.userInfo()
        })
        
    },
    methods : {
        //=>提交用户信息
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let formNamesVal = this.$refs[formName].$options.propsData.model;
                     let userId = sessionStorage.getItem("userId") ;
                    let params = {
                        act : 'updateUser',
                        name:formNamesVal.name,
                        phone:formNamesVal.phone,
                        password:formNamesVal.password,
                        userId:formNamesVal.userId,
                        locationCode:formNamesVal.locationCode,
                        staffId:formNamesVal.staffId,
                        accessLevel:formNamesVal.accessLevel,
                        userLevel:formNamesVal.userLevel,
                        userId
                    }
                    debugger
                    this.updateUser( params );
                    this.userInfo()
                } else {
                    return false;
                }
            });
        },
        /**取消返回上一页*/
        cancel(){
            this.$router.go(-1)
        },
        /**
         * 加载用户信息
         */
        userInfo(){
             let userId2 = sessionStorage.getItem('userId');
             let userLevel = sessionStorage.getItem('userLevel');
             let that = this;
            that.findAllUser(userId2,userLevel).then( res =>{
                if(res.length > 0 && res[0].userId == userId2){
                    that.ruleForm = res[0];
                     this.ruleForm.checkPass = res[0].password;
                    that.getLocationDes(res[0].locationCode).then( res1 => {
                         that.userInformation = res[0];
                         that.userInformation.location = res1;
                    })
                }else{
                    var filterUser = res.filter(elem => {
                        return elem.userId == userId2;
                    })
                    if(filterUser.length > 0){
                        that.ruleForm = filterUser[0];
                        that.getLocationDes(filterUser[0].locationCode).then( res1 => {
                            that.userInformation = filterUser[0];
                            that.userInformation.location = res1;
                        })
                    }
                }
            })
            if(userLevel == "S"){
                this.userLevel = '系统管理员'
            }else if(userLevel == "A"){
                this.userLevel = '管理员'
            }else{
                this.userLevel = '普通用户'
            }
        },
        //公共message
        _message(message,type){
            this.$message({
                showClose: true,
                message,
                type
            });
        },
        //更新用户信息
        async updateUser( params ){
            await axios.post(apis.baseURL, params).then((res)=>{
                if(res.data.status == true){
                    this._message('更新用户成功','success')
                    debugger
                    sessionStorage.setItem("phone",params.phone);
                    window.location.reload()
                }else{
                    this._message('更新用户失败','error')
                }
            }).catch((error)=>{
                this._message('数据请求错误','error')  
            })
        }
    }
}
</script>
<style lang="less" scoped>
    .content{
        font-family: "Hiragino Sans GB",Helvetica;
        .left, .right{
            background: white;
            
        }
        .left {
            padding:30px 20px;
            .info{
                font-size: 18px;
                .info-list{
                    padding:8px 20px;
                }
            }
        }
        .right {
            padding:30px;
        }
    }
</style>
